import { storeToRefs } from 'pinia';
import { computed, defineComponent } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import { PayoutAccountsTypes } from '@/types/payout-accounts';
var PayoutComponents = PayoutAccountsTypes.PayoutComponents;
export default defineComponent({
    name: 'DeleteConfirmation',
    components: {
        Button,
    },
    setup() {
        const payoutAccountsStore = usePayoutAccountsStore();
        const { currentStep, error, loading } = storeToRefs(payoutAccountsStore);
        const deleteButtonsCTA = computed(() => [
            {
                disabled: !!loading.value,
                text: loading.value || 'Yes, delete this account',
                onClick: async (event) => {
                    event.preventDefault();
                    await payoutAccountsStore.deletePayoutAccount();
                    currentStep.value = PayoutComponents.ManagePayouts;
                    payoutAccountsStore.resetActivePayoutAccount();
                },
            },
            {
                disabled: !!loading.value,
                text: "No, don't delete this account",
                variant: 'outline',
                onClick: () => {
                    currentStep.value = PayoutComponents.ManagePayouts;
                    payoutAccountsStore.resetActivePayoutAccount();
                },
            },
        ]);
        return {
            deleteButtonsCTA,
            error,
        };
    },
});
